exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sku-value[data-v-58e44e06] {\n  margin-right: 10px;\n}\n.sku-img[data-v-58e44e06] {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n.key-item[data-v-58e44e06] {\n  padding-bottom: 10px;\n}\n.key-item .iconfont[data-v-58e44e06] {\n    color: #999;\n}\n.upload-box[data-v-58e44e06] {\n  width: 50px;\n  height: 50px;\n}\n.upload-box .avatar-uploader-icon[data-v-58e44e06] {\n    line-height: 50px;\n    font-size: 20px;\n}\n.grade-setting-col[data-v-58e44e06] {\n  line-height: 40px;\n}\n.btn-gap[data-v-58e44e06] {\n  margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-58e44e06","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/goods/attributes/params.vue
// module id = 1496
// module chunks = 0